export const tagsEndpoints = {
  createTag: { method: 'post', path: '/create' },
  createRequestTag: { method: 'post', path: '/request/create' },
  deleteRequestTag: { method: 'post', path: '/request/delete' },
  createSupplierTag: { method: 'post', path: '/supplier/create' },
  deleteSupplierTag: { method: 'post', path: '/supplier/delete' },
  getTags: { method: 'get', path: '/' },
  getTagsByOrganisationSupplierId: { method: 'get', path: '/organisation-supplier/{organisationSupplierId}' },
} as const
